import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  BackofficeConversationExperimentsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeConversationExperimentsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeConversationExperimentsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeConversationExperimentsResponseDataSchema>
>
type OnSuccessFn = (data: Response) => void

const getBackofficeConversationExperimentsQueryKey = (query?: Query) =>
  ["backofficeConversationExperiments", query].filter((e) => e)

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeConversationExperimentsQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeConversationExperimentsQueryKey(query),
    staleTime: MINUTES_TO_MILLIS,
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/experiments", {
        params: query,
        signal,
      })
      onSuccess?.(data)
      return data.data
    },
  })
}
